package horcrux.frontend.common.configs

import web.cssom.Color
import web.cssom.pt

object StaticContentConfigs {
    const val LOGO_PATH: String = "https://storage.googleapis.com/horcrux-public/images/logo.png"
    const val LOGO_NO_TEXT_PATH: String = "https://storage.googleapis.com/horcrux-public/images/logo_no_text.png"
    const val CHROME_EXTENSION_URL: String =
        "https://chromewebstore.google.com/detail/the-grok-app/fhkajaliakkbdjolbpjmbeghmhnlipjh?pli=1"
    val BLUE: Color = Color("#6598eb")
    val GRAY: Color = Color("gray")
    val WHITE: Color = Color("white")
    val BLACK: Color = Color("black")
    val RED: Color = Color("#d32f2f")
    val APP_BAR_HEIGHT = 50.pt
    val CONTACT_URL_BY_LABEL: Map<String, String> = mapOf(
        "Email" to "mailto:contact@thegrokapp.com",
        "Reddit" to "https://reddit.com/r/thegrokapp/",
    )
}
